import React, { useEffect, useState } from 'react';
import { createHtmlComponent, setElementStyle } from './DialogUtils';
import { createPortal } from 'react-dom';

export const DEFAULT_WIDGET_STYLE: React.CSSProperties = {
  position: 'fixed',
};

export interface DialogWidgetOptions {
  children?: React.ReactNode;
  id: string;
  className: string;
  zIndex?: number;
  style?: React.CSSProperties;
  appendTo?: HTMLElement;
}

export function DialogWidget({
  children,
  className,
  zIndex,
  style,
  appendTo,
  id,
}: DialogWidgetOptions): React.ReactPortal {
  const styleObject: React.CSSProperties = { ...DEFAULT_WIDGET_STYLE, ...style };
  styleObject.zIndex = zIndex;

  // Create new Component only when :appendTo, actions" changed
  const [widget] = useState(() => createHtmlComponent({ zIndex, styleObject, className, appendTo, id }));
  setElementStyle(widget, { className, style: styleObject });

  useEffect(() => {
    return () => {
      if (!widget) return;
      if (!widget.parentElement) return;

      widget.parentElement.removeChild(widget);
    };
    // component unmount only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return createPortal(<>{children}</>, widget!);
}
